import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { Alert, Form } from 'react-bootstrap';
import { DateTimeInput, Select } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withTranslation } from 'react-i18next';

const NewFormSettings = ({ forms, error, handleSubmit, pristine, submitting, isReadonly, submitSucceeded, initialValues, t }) => {
	return (
		<Form horizontal onSubmit={handleSubmit}>
			{error && <Alert bsStyle='danger'>{error}</Alert>}
			<Select name='formId' horizontal required label={t('IndividualConsultationForm_Form')} data={forms} validate={validators.required} />
			<Field name='date' component={DateTimeInput} showTime={false} disabled={isReadonly} horizontal required label={t('IndividualConsultationForm_Date')} validate={[validators.required]} />
		</Form>
	);
};

export default reduxForm({ form: 'newFormSettings' })(withTranslation()(NewFormSettings));